export default {
  /**
   * Date range
   */
  'Month to date': 'Month to date',
  'Year to date': 'Year to date',
  'Last month': 'Last month',
  'Last 7 days': 'Last 7 days',
  'Last 14 days': 'Last 14 days',
  'Last 30 days': 'Last 30 days',
  'Last 90 days': 'Last 90 days',
  'Last 180 days': 'Last 180 days',
  'Last 3 months': 'Last 3 months',
  'Last 6 months': 'Last 6 months',
  'Last 1 year': 'Last 1 year',

  /**
   * Granularity
   */
  Daily: 'Daily',
  Monthly: 'Monthly',

  /**
   * Category / resource
   */
  productCode: 'Product',
  service: 'Service',
  account: 'Account',
  region: 'Region',
  instanceType: 'Instance Type',
  usageType: 'Usage Type',
  tags: 'Tags',
  tag: 'Tag',
  tag_resource: 'Tag resource',

  /**
   * Chart type
   */
  Stacked: 'Stacked',
  Bar: 'Bar',
  Line: 'Line',

  /**
   * Line stroke type
   */
  Solid: 'Solid',
  'Solid with bullet': 'Solid with bullet',
  Dashed: 'Dashed',
  'Dashed with bullet': 'Dashed with bullet',

  /**
   * Colors
   */
  red: 'Red',
  pink: 'Pink',
  purple: 'Purple',
  deep_purple: 'Deep blue',
  indigo: 'Indigo',
  blue: 'Blue',
  light_blue: 'Light blue',
  cyan: 'Cyan',
  teal: 'Teal',
  green: 'Green',
  light_green: 'Light green',
  lime: 'Lime',
  yellow: 'Yellow',
  amber: 'Amber',
  orange: 'Orange',
  deep_orange: 'Deep orange',
  brown: 'Brown',
  grey: 'Grey',
  blue_grey: 'Blue grey',

  /**
   * File type
   */
  CSV: 'CSV',
  XLSX: 'XLSX',
  JSON: 'JSON',
  HTML: 'HTML',
  PNG: 'PNG',
  JPG: 'JPG',
  SVG: 'SVG',
  PDF: 'PDF',
};
